import { Dialog, DialogTitle, styled } from "@mui/material";

export const CustomDialog = styled(Dialog)<{ scale: number }>`
	.MuiPaper-root {
		transform: scale(${(props) => props?.scale});
		border-radius: 25px;
		display: flex;
		flex-direction: column;
		width: 395px;
		min-width: 395px;
		height: 390px;
		min-height: 390px;
		margin: 0px;

		/* @media (max-height: 590px) {
			flex-direction: row;
			width: 700px;
			min-width: 700px;
			height: 300px;
			min-height: 300px;
		} */
	}
`;

export const CustomDialogTitle = styled(DialogTitle)`
	background-color: SteelBlue;
	background-position: center;
	background-size: cover;
	overflow: hidden;
	width: auto;
	padding: 0px;
	height: 200px;

	/* @media (max-height: 590px) {
		height: auto;
		width: 50%;
	} */
`;
